import React from "react";
import {useTheme} from "@mui/material/styles";
import {Box} from "@mui/material";
import "./SkeletonLoadingTS.css";

export const SkeletonLoadingTS = () => {
  const theme = useTheme();

  return (
    <Box
      className="skeleton-ts-container"
      sx={{
        backgroundColor: theme.palette.windowScreen?.background
      }}
    >
      <div className="skeleton-ts-content">
        <img src={require("../assets/ts-loading-bw.png")} alt="Loading..." className="skeleton-ts-image" />
      </div>
    </Box>
  );
};

export default SkeletonLoadingTS;
